import React from 'react';

interface SidebarMenuProps {
  title: string;
  children: React.ReactNode;
}

export const SidebarMenu: React.FC<SidebarMenuProps> = ({ title, children }) => {
  return (
    <div className="flex flex-col gap-2">
      <h3 className="text-xs font-semibold uppercase tracking-wider text-default-400 px-2 mb-1">
        {title}
      </h3>
      <div className="flex flex-col gap-1">
        {children}
      </div>
    </div>
  );
};